<template>
	<div class="home_page">
		<div class="hm_pc" v-if="!isPhone">
			<swiper class="swiper_box1" :options="swiperOption" ref="mySwiper" v-if="swiperList.length">
				<swiper-slide class="swiper_item" v-for="(item, index) in swiperList" :key="index">
					<div class="flex">
						<img :src="staticImg + item.image" />
					</div>
				</swiper-slide>
				<div class="swiper-pagination" slot="pagination"></div>
			</swiper>
			<div class="hn_box">
				<div class="hn_list flex1">
					<div class="news_item1">
						<swiper class="swiper_box2" :options="swiperOption2" ref="mySwiper2" v-if="swiperList.length">
							<swiper-slide class="swiper_item2" v-for="(item, index) in splist2" :key="index">
								<div class="flex2 sp2_box">
									<img :src="item.image" />
									<div class="sp2_tit ellip">{{ item.title }}</div>
								</div>
							</swiper-slide>
						</swiper>
					</div>
					<div class="news_item2">
						<div class="ntm_tit flex1">
							<span>集团新闻</span>
							<img @click="toNews(1)" src="@/images/right.png">
						</div>
						<div class="ntm flex1" v-for="item in yaowen" :key="item.id" @click="toDetail(item,1)">
							<span class="ellip">{{ item.title }}</span>
							<span>{{ item.addtime.slice(0, 10) }}</span>
						</div>
					</div>
					<div class="news_item2">
						<div class="ntm_tit flex1">
							<span>党的建设</span>
							<img @click="toNews(3)" src="@/images/right.png">
						</div>
						<div class="ntm flex1" v-for="item in dangjian" :key="item.id" @click="toDetail2(item)">
							<span class="ellip">{{ item.title }}</span>
							<span>{{ item.addtime.slice(0, 10) }}</span>
						</div>
					</div>
					<div class="news_item2">
						<div class="ntm_tit flex1">
							<span>基层动态</span>
							<img @click="toNews(2)" src="@/images/right.png">
						</div>
						<div class="ntm flex1" v-for="item in jiceng" :key="item.id" @click="toDetail(item,2)">
							<span class="ellip">{{ item.title }}</span>
							<span>{{ item.addtime.slice(0, 10) }}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="bus_area">
				<p class="ba_tit">业务领域</p>
				<div class="scroll_box">
					<div class="image_track flex3" :style="{ transform: `translate3d(${position}px, 0, 0)` }" @mouseenter="pauseScroll"
						@mouseleave="resumeScroll">
						<div class="image_wrap" v-for="(item, index) in bslist" :key="index" @click.stop="toBuss(item)">
							<img :src="staticImg + item.image" class="scroll_image">
							<img class="img_icon" :src="staticImg + item.images" />
							<p class="img_text">{{ item.title }}</p>
						</div>
						<div class="image_wrap" v-for="(item, index) in bslist" :key="index + bslist.length" @click.stop="toBuss(item)">
							<img :src="staticImg + item.image" class="scroll_image">
							<img class="img_icon" :src="staticImg + item.images" />
							<p class="img_text">{{ item.title }}</p>
						</div>
					</div>
				</div>
			</div>
			<div class="area_two">
				<div class="area_two_con flex1">
					<div class="at_left">
						<div class="atl_tit1">关于我们</div>
						<div class="atl_tit2">
							徐州市交通控股集团有限公司在徐州市深化国企改革进程中应运而生，2018年8月组建，2019年1月挂牌，主要承担除地铁以外的交通基础设施投资、建设、运营等职责，同时开拓交通关联性产业，2020年7月顺利通过主体信用等级AAA认证…
						</div>
						<ul class="flex1 at_data">
							<li>
								<p style="color: #00409a;">AAA</p>
								<p>信用等级</p>
							</li>
							<li>
								<p>7,000+</p>
								<p>人员数[人]</p>
							</li>
							<li>
								<p>700+</p>
								<p>总资产[亿]</p>
							</li>
						</ul>
						<a class="btns" @click="learnMore">了解更多</a>
					</div>
					<div class="at_right" v-if="rcdata.file">
						<video :src="staticImg + rcdata.file" :poster="staticImg + rcdata.image" controls></video>
					</div>
				</div>
			</div>
			<Footer></Footer>
		</div>
		<div class="hm_ph" v-if="isPhone">
			<Header2 :searchShow="true" pageTitle="徐州交控集团"></Header2>
			<swiper class="swiper_box1" :options="swiperOption" ref="mySwiper">
				<swiper-slide class="swiper_item" v-for="(item, index) in swiperList" :key="index">
					<div class="flex2">
						<img :src="staticImg + item.image" />
					</div>
				</swiper-slide>
			</swiper>
			<div class="hn_box">
				<div class="hn_list">
					<div class="news_item1">
						<swiper class="swiper_box2" :options="swiperOption2" ref="mySwiper2" v-if="swiperList.length">
							<swiper-slide class="swiper_item2" v-for="(item, index) in splist2" :key="index">
								<div class="flex2 sp2_box">
									<img :src="item.image" />
									<div class="sp2_tit ellip">{{ item.title }}</div>
								</div>
							</swiper-slide>
						</swiper>
					</div>
					<div class="news_item2">
						<div class="ntm_tit flex1">
							<span>集团新闻</span>
							<img @click="toNews(1)" src="@/images/right.png">
						</div>
						<div class="ntm flex1" v-for="item in yaowen" :key="item.id" @click="toDetail(item,1)">
							<span class="ellip">{{ item.title }}</span>
							<span>{{ item.addtime.slice(0, 10) }}</span>
						</div>
					</div>
					<div class="news_item2">
						<div class="ntm_tit flex1">
							<span>党的建设</span>
							<img @click="toNews(3)" src="@/images/right.png">
						</div>
						<div class="ntm flex1" v-for="item in dangjian" :key="item.id" @click="toDetail2(item)">
							<span class="ellip">{{ item.title }}</span>
							<span>{{ item.addtime.slice(0, 10) }}</span>
						</div>
					</div>
					<div class="news_item2">
						<div class="ntm_tit flex1">
							<span>基层动态</span>
							<img @click="toNews(2)" src="@/images/right.png">
						</div>
						<div class="ntm flex1" v-for="item in jiceng" :key="item.id" @click="toDetail(item,2)">
							<span class="ellip">{{ item.title }}</span>
							<span>{{ item.addtime.slice(0, 10) }}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="bus_area">
				<p class="ba_tit">业务领域</p>
				<div class="area_two_box">
					<div class="area_two_item" v-for="(item, index) in bslist" :key="item.id">
						<div class="img_box flex2" @click="toBusiness(index)">
							<img class="img_img" :src="staticImg + item.image" />
							<img class="img_icon" :src="staticImg + item.images" />
							<p class="img_text">{{ item.title }}</p>
						</div>
					</div>
				</div>
			</div>
			<div class="area_two">
				<div class="area_two_con">
					<div class="at_left">
						<div class="atl_tit1">关于我们</div>
						<div class="atl_tit2">
							徐州市交通控股集团有限公司在徐州市深化国企改革进程中应运而生，2018年8月组建，2019年1月挂牌，主要承担除地铁以外的交通基础设施投资、建设、运营等职责，同时开拓交通关联性产业，2020年7月顺利通过主体信用等级AAA认证…
						</div>
                        <ul class="flex1 at_data">
							<li>
								<p>AAA</p>
								<p>信用等级</p>
							</li>
							<li>
								<p>7,000+</p>
								<p>人员数[人]</p>
							</li>
							<li>
								<p>700+</p>
								<p>总资产[亿]</p>
							</li>
						</ul>
						<a class="btns" @click="learnMore">了解更多</a>
					</div>
					<div class="at_right">
						<video :src="staticImg + rcdata.file" :poster="staticImg + rcdata.image" controls></video>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
let vm = null;
export default {
	data() {
		return {
			staticImg: this.$staticImg,
			position: 0,
			speed: 2.5,
			animationId: null,
			isPaused: false,
			lastTimestamp: null,
			bslist: [],
			imageWidth: 400,
			gap: 50,
			swiperOption: {
				pagination: {
					el: ".swiper-pagination",
					clickable: true,
				},
				initialSlide: 0,
				mousewheel: false,
				speed: 2000,
                loop: true,
				autoplay: {
					delay: 3000,
				},
			},
			swiperOption2: {
				loop: true,
				speed: 2000,
				autoplay: {
					delay: 3000,
				},
				on: {
					click: (e) => {
						const realIndex = this.$refs.mySwiper2.$swiper.realIndex;
						this.tospDetail(realIndex);
					}
				}
			},
			swiperList: [],
			splist2: [],
			dangjian: [],
			yaowen: [],
			jiceng: [],
			bslist: [],//业务领域滚动轮播
			staticImg: this.$staticImg,
			rcdata: {},
			isPhone: this.$isMobile,
		};
	},
	computed: {
		groupWidth() {
			return (this.imageWidth + this.gap) * this.bslist.length;
		},
		totalWidth() {
			return this.groupWidth * 2;
		},
	},
	mounted() {
		this.business();
		this.startScroll();
	},
	created() {
		this.swiper();
		this.partybuilding();
		this.homeNews();
		this.unitnews();
		this.about();
		this.tyoebanner();
	},
	beforeDestroy() {
		this.stopScroll();
	},
	methods: {
		// 集团简介
		async about() {
			const res = await this.$api.about({
				type: 1,
			});
			if (res.code == 1) {
				this.rcdata = res.data;
			}
		},
		// 轮播图2
		async tyoebanner() {
			const res = await this.$api.tyoebanner();
			if (res.code == 1) {
				this.splist2 = res.data;
				for (let i = 0; i < this.splist2.length; i++) {
					this.splist2[i].image = this.$staticImg + this.splist2[i].image
				}
			}
		},
		// 轮播图
		async swiper() {
			const res = await this.$api.swiper();
			if (res.code == 1) {
				this.swiperList = res.data;
			}
		},
		// 党的建设
		async partybuilding() {
			const res = await this.$api.partybuilding();
			if (res.code == 1) {
				this.dangjian = res.data;
			}
		},
		// 集团要闻
		async homeNews() {
			const res = await this.$api.homeNews();
			if (res.code == 1) {
				this.yaowen = res.data;
			}
		},
		// 基层动态
		async unitnews() {
			const res = await this.$api.unitnews();
			if (res.code == 1) {
				this.jiceng = res.data;
			}
		},
		// 业务领域
		async business() {
			const res = await this.$api.business();
			if (res.code == 1) {
				this.bslist = res.data;
			}
		},
		startScroll(timestamp) {
			if (!timestamp) {
				this.lastTimestamp = performance.now();
				this.animationId = requestAnimationFrame(this.startScroll);
				return;
			}
			const deltaTime = timestamp - this.lastTimestamp;
			this.lastTimestamp = timestamp;
			if (!this.isPaused) {
				this.position -= (this.speed * deltaTime) / 16;
				if (this.position <= -this.groupWidth) {
					this.position = 0;
				}
			}
			this.animationId = requestAnimationFrame(this.startScroll);
		},
		pauseScroll() {
			this.isPaused = true;
		},
		resumeScroll() {
			this.isPaused = false;
			this.lastTimestamp = performance.now();
		},
		stopScroll() {
			cancelAnimationFrame(this.animationId);
		},
		toBusiness(index) {
			this.$router.push('/business?sort=' + (index + 1));
		},
		toBuss(item) {
			if (item.title == '工程建设') {
				this.$router.push('/business?sort=' + 1);
			}
			if (item.title == '综合物流') {
				this.$router.push('/business?sort=' + 2);
			}
			if (item.title == '公共出行') {
				this.$router.push('/business?sort=' + 3);
			}
		},
		toNews(a) {
			if (a == 1 || a == 2) this.$router.push('/news/newsList?sort=' + a);
			if (a == 3) this.$router.push('/partyBuilding/partyCenter');
		},
		toDetail(item, a) {
			this.$router.push('/news/newsDetail?id=' + item.id + '&sort=' + a);
		},
		toDetail2(item) {
			this.$router.push('/partyBuilding/partyDetail?id=' + item.id + '&sort=1');
		},
		tospDetail(index) {
			this.$router.push('/news/newsDetail?id=' + this.splist2[index].id + '&sort=' + 1);
		},
		learnMore() {
			this.$router.push('/aboutUs?sort=' + 1);
		},
		stopAutoplay() {
			this.$nextTick(() => {
				this.$refs.mySwiper2.$swiper.autoplay.stop();
			});
		},
		startAutoplay() {
			this.$refs.mySwiper2.$swiper.autoplay.start();
		}
	}
};
</script>
<style lang="scss">
.home_page {
	.hm_pc {
		padding-top: 90px;
		min-width: 1100px;

		.swiper_box1 {
			.swiper_item {
				width: 100%;
				height: 370px;

				div {
					overflow: hidden;
					width: 100%;
					height: 370px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
					img {
						width: 1920px;
						height: 370px;
					}
				}
			}
		}

		.hn_box {
			background-color: #f7f7f7;
			padding-top: 60px;

			.hn_list {
				flex-wrap: wrap;
				width: 1440px;
				margin: 0 auto;
				align-items: flex-start;
				.news_item1 {
					width: 650px;
					height: 350px;
					margin-bottom: 45px;
					.swiper_box2 {
						width: 650px;
						height: 350px;
						.swiper_item2 {
							.sp2_box {
								position: relative;
								width: 650px;
								height: 350px;
								overflow: hidden;
								cursor: pointer;
								img {
									width: 650px;
									height: auto;
								}
								.sp2_tit {
									position: absolute;
									left: 0;
									right: 0;
									bottom: 0;
									z-index: 11;
									background-color: rgba(0, 0, 0, 0.3);
									color: #fff;
									padding: 10px 15px;
									font-size: 16px;
								}
							}
						}
					}
				}

				.news_item2 {
					width: 650px;
					height: 310px;
					margin-bottom: 45px;

					.ntm_tit {
						border-bottom: 1px solid #ededed;
						padding-bottom: 20px;

						span {
							font-size: 26px;
							font-weight: bold;
						}

						img {
							width: 15px;
							height: 15px;
							cursor: pointer;
						}
					}

					.ntm {
						margin-top: 20px;
						cursor: pointer;

						&:hover {
							color: #3a78f3;
						}

						span {
							&:nth-child(1) {
								flex: 1;
								font-size: 16px;
							}

							&:nth-child(2) {
								margin-left: 20px;
							}
						}
					}
				}
			}
		}

		.bus_area {
			background-color: #fff;
			padding: 70px 0;

			.ba_tit {
				text-align: center;
				color: #00409a;
				font-size: 40px;
				font-weight: bold;
				margin-bottom: 50px;
			}

			.scroll_box {
				width: 1400px;
				height: 375px;
				margin: 0 auto;
				margin-top: 70px;
				margin-bottom: 30px;
				overflow: hidden;
				position: relative;
				.image_track {
					display: flex;
					position: absolute;
					top: 0;
					left: 0;
					z-index: 1;
					will-change: transform;
					transform: translate3d(0, 0, 0);
					transition: none;
					width: calc(2 * ((400px + 50px) * 3));
					.image_wrap {
						margin-right: 50px;
						flex-shrink: 0;
						position: relative;
						cursor: pointer;
						.scroll_image {
							width: 400px;
							height: 375px;
							object-fit: cover;
							// border-radius: 8px;
							box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
							transition: transform 0.3s ease;
							will-change: transform;
						}
						.img_icon {
							position: absolute;
							left: 35px;
							bottom: 95px;
							z-index: 9999;
                            opacity: 0.7;
						}

						.img_text {
							position: absolute;
							left: 35px;
							bottom: 45px;
							color: #fff;
							font-size: 28px;
							z-index: 9999;
                            opacity: 0.7;
						}
					}
				}
			}
		}

		.area_two {
			padding: 110px 0 100px 0;
            background-image: url("../../images/bg1.jpg");
            background-size: 100% 100%;
			background-repeat: no-repeat;
			.area_two_con {
				width: 1440px;
				margin: 0 auto;

				.at_left {
					width: 600px;
					.atl_tit1 {
						font-size: 38px;
						font-weight: bold;
						color: #00409a;
					}

					.atl_tit2 {
						margin-top: 30px;
						font-size: 18px;
						line-height: 2;
					}
					.at_data {
						margin-top: 30px;

						li {
							p {
								&:nth-child(1) {
									font-size: 40px;
									font-weight: bold;
								}

								&:nth-child(2) {
									font-size: 16px;
									margin-top: 10px;
									color: #888;
								}
							}
						}
					}
					.btns {
						display: block;
						cursor: pointer;
						width: 130px;
						height: 48px;
						line-height: 48px;
						color: rgb(255, 255, 255);
						font-size: 18px;
						text-transform: capitalize;
						font-family: BEBAS;
						margin-top: 50px;
						padding: 0px 30px;
						border-radius: 3px;
						border-width: 1px;
						border-style: solid;
						border-color: rgb(0, 91, 160);
						background-color: rgb(0, 91, 160);
						background: #005ba0 url(../../images/rddr.png) 80% center
							no-repeat;
						border-image: initial;
						transition: 0.5s;
					}

					.btns:hover {
						background: #005ba0 url(../../images/rddr.png) 87% center
							no-repeat;
						box-shadow: 0 1px 6px 0px rgba(0, 91, 160, 1);
					}
				}

				.at_right {
					flex: 1;
					padding-left: 80px;

					video {
						width: 100%;
						height: 480px;
						background-color: #000;
						object-fit: cover;
					}
				}
			}
		}
	}

	@media screen and (max-width: 1650px) {
		.hm_pc {
			.hn_box {
				.hn_list {
					width: 1200px;
					.news_item1 {
						width: 560px;
						height: 330px;
						.swiper_box2 {
							width: 560px;
							height: 330px;
							.swiper_item2 {
								.sp2_box {
									width: 560px;
									height: 330px;
									img {
										width: 560px;
									}
								}
							}
						}
					}

					.news_item2 {
						width: 560px;
						height: 310px;
					}
				}
			}
			.bus_area {
				.scroll_box {
					width: 1200px;
				}
			}
			.area_two {
				.area_two_con {
					width: 1200px;
					margin: 0 auto;

					.at_left {
						width: 500px;
					}

					.at_right {
						flex: 1;
						padding-left: 70px;

						video {
							height: 450px;
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 1400px) {
		.hm_pc {
			.hn_box {
				.hn_list {
					width: 1100px;
					.news_item1 {
						width: 500px;
						height: 330px;
						.swiper_box2 {
							width: 500px;
							height: 330px;
							.swiper_item2 {
								.sp2_box {
									width: 500px;
									height: 330px;
									img {
										width: 500px;
									}
								}
							}
						}
					}

					.news_item2 {
						width: 500px;
						height: 310px;
						margin-bottom: 35px;
					}
				}
			}
			.bus_area {
				.scroll_box {
					width: 1100px;
				}
			}
			.area_two {
				padding: 110px 0 100px 0;

				.area_two_con {
					width: 1100px;

					.at_left {
						width: 400px;

						.atl_tit1 {
							font-size: 35px;
						}
						.atl_tit2 {
							margin-top: 20px;
							font-size: 16px;
							line-height: 1.8;
						}
						.at_data {
							margin-top: 20px;

							li {
								p {
									&:nth-child(1) {
										font-size: 36px;
									}

									&:nth-child(2) {
										font-size: 16px;
									}
								}
							}
						}
					}

					.at_right {
						flex: 1;
						padding-left: 70px;

						video {
							height: 400px;
						}

						.at_data {
							li {
								p {
									&:nth-child(1) {
										font-size: 35px;
									}
								}
							}
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 1300px) {
		.hm_pc {
			.hn_box {
				.hn_list {
					width: 1000px;
					.news_item1 {
						width: 460px;
						height: 330px;
						.swiper_box2 {
							width: 460px;
							height: 330px;
							.swiper_item2 {
								.sp2_box {
									width: 460px;
									height: 330px;
									img {
										width: 460px;
									}
								}
							}
						}
					}

					.news_item2 {
						width: 460px;
						height: 330px;
						margin-bottom: 35px;
					}
				}
			}
			.bus_area {
				.scroll_box {
					width: 1000px;
				}
			}
			.area_two {
				padding: 110px 0 100px 0;

				.area_two_con {
					width: 1000px;

					.at_left {
						width: 400px;
						.btns {
							margin-top: 40px;
						}
					}

					.at_right {
						flex: 1;
						padding-left: 70px;

						video {
							height: 400px;
						}

						.at_data {
							li {
								p {
									&:nth-child(1) {
										font-size: 35px;
									}
								}
							}
						}
					}
				}
			}
		}
	}

	.hm_ph {
		padding-top: 1.23rem;
		padding-bottom: 80px;

		.swiper_box1 {
			.swiper_item {
				width: 100%;
				height: 3.5rem;

				div {
					overflow: hidden;
					width: 100%;
					height: 3.5rem;

					img {
						width: 100%;
						height: 3.5rem;
					}
				}
			}
		}

		.hn_box {
			background-color: #f7f7f7;

			.hn_list {
				width: 100%;
				padding: 0.35rem 0.35rem 0.1rem 0.35rem;
				box-sizing: border-box;

				.news_item1 {
					width: 100%;
					background-color: #fff;
					margin-bottom: 0.5rem;
					.swiper_box2 {
						width: 100%;
						height: 6rem;
						.swiper_item2 {
							.sp2_box {
								position: relative;
								width: 100%;
								height: 6rem;
								overflow: hidden;
								cursor: pointer;
								img {
									width: 100%;
									height: auto;
								}
								.sp2_tit {
									position: absolute;
									left: 0;
									right: 0;
									bottom: 0;
									z-index: 11;
									background-color: rgba(0, 0, 0, 0.3);
									color: #fff;
									padding: 10px 15px;
									font-size: 16px;
								}
							}
						}
					}
				}

				.news_item2 {
					margin-bottom: 0.5rem;
					background-color: #fff;
					padding: 0 0.3rem 0.5rem 0.3rem;
					box-sizing: border-box;

					.ntm_tit {
						border-bottom: 1px solid #ededed;
						padding: 0.4rem 0;

						span {
							font-size: 0.5rem;
							font-weight: bold;
						}

						img {
							width: 0.3rem;
						}
					}

					.ntm {
						margin-top: 20px;
						cursor: pointer;

						&:hover {
							color: #3a78f3;
						}

						span {
							&:nth-child(1) {
								flex: 1;
								font-size: 0.4rem;
							}

							&:nth-child(2) {
								font-size: 0.4rem;
								margin-left: 0.5rem;
								color: #666;
							}
						}
					}
				}
			}
		}

		.bus_area {
			background-color: #fff;
			padding: 0.5rem 0.35rem;

			.ba_tit {
				text-align: center;
				color: #00409a;
				font-size: 0.6rem;
				font-weight: bold;
				margin-bottom: 0.6rem;
			}

			.area_two_box {
				.area_two_item {
					width: 100%;
					margin-bottom: 0.5rem;

					.img_box {
						width: 100%;
						position: relative;

						.img_img {
							width: 100%;
						}

						.img_icon {
							position: absolute;
							left: 0.8rem;
							bottom: 2.2rem;
							z-index: 11;
						}

						.img_text {
							position: absolute;
							left: 0.8rem;
							bottom: 1.1rem;
							color: #fff;
							font-size: 0.7rem;
							z-index: 22;
						}
					}
				}
			}
		}

		.area_two {
			background-color: #f7f7f7;
			padding: 0.5rem 0.35rem;

			.area_two_con {
				.at_left {
					width: 100%;

					.atl_tit1 {
						text-align: center;
						color: #00409a;
						font-size: 0.6rem;
						font-weight: bold;
						margin-bottom: 0.5rem;
					}

					.atl_tit2 {
						font-size: 0.38rem;
						line-height: 2;
					}
                    .at_data {
						margin-top: 0.6rem;

						li {
							p {
								&:nth-child(1) {
									font-size: 0.7rem;
                                    font-weight: bold;
								}

								&:nth-child(2) {
									font-size: 0.35rem;
									margin-top: 0.25rem;
									color: #888;
								}
							}
						}
					}
					.btns {
						display: block;
						width: 130px;
						height: 48px;
						line-height: 48px;
						color: rgb(255, 255, 255);
						font-size: 18px;
						text-transform: capitalize;
						font-family: BEBAS;
                        margin: 50px auto;
						padding: 0px 30px;
						border-radius: 3px;
						border-width: 1px;
						border-style: solid;
						border-color: rgb(0, 91, 160);
						background-color: rgb(0, 91, 160);
						background: #005ba0 url(../../images/rddr.png) 80% center
							no-repeat;
						border-image: initial;
						transition: 0.5s;
					}

					.btns:hover {
						background: #005ba0 url(../../images/rddr.png) 87% center
							no-repeat;
						box-shadow: 0 1px 6px 0px rgba(0, 91, 160, 1);
					}
				}

				.at_right {
					margin-top: 0.5rem;

					video {
						width: 100%;
						height: 6rem;
						background-color: #000;
						object-fit: cover;
					}
				}
			}
		}
	}
}
</style>